<crm-auto-complete
  [(value)]="selectedContragent"
  (valueChange)="selectedContragentChange.emit($event)"
  [styleClass]="styleClass"
  [class]="class"
  [disabled]="disabled"
  [inputStyle]="inputStyle"
  [suggestions]="contragents"
  [field]="field"
  [virtualScroll]="true"
  [virtualScrollItemSize]="60"
  [inputStyleClass]="inputStyleClass"
  dataKey="id"
  [appendTo]="appendTo"
  [placeholder]="placeholder"
  [showClear]="showClear"
  [isError]="isError"
  (completeMethod)="customSearch ? contragentSearch.emit($event.query) : searchContragent($event.query)">
  <ng-template
    let-item="item"
    #itemTemplate>
    <div *ngIf="toContragent(item) as contragent">
      <div>{{ contragent.name }}</div>
      <div
        *ngIf="contragent.inn"
        class="frm-color-green">
        ИНН: {{ contragent.inn }}
      </div>
      <div
        *ngIf="contragent.kpp"
        class="text-gray-500">
        КПП: {{ contragent.kpp }}
      </div>
    </div>
  </ng-template>
</crm-auto-complete>
